import sortBy from 'lodash/sortBy';
import * as types from './constants';

const sortByName = array => sortBy(array, ['name']);
const initialState = [];
const taxes = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.FETCH_TAXES:
      return sortByName(payload || []);

    case types.FETCH_TAX:
    case types.UPDATE_TAX:
    case types.ADD_TAX:
      return sortByName(
        state.filter(tax => tax.id !== payload.id).concat([payload]),
      );

    case types.DELETE_TAX:
      return sortByName(
        state.filter(tax => tax.id !== payload)
      );

    default:
      return state;
  }
};

export default taxes;
